import Skeleton from '../../../../../components/Skeleton';
import styles from './style.module.scss';

const range = (length: number) => Array.from({ length }, (_, index) => index);

interface Props {
    /** Number of collapsed accordion placeholders. */
    sections?: number;
};

/** Loading placeholder for the exam sheet / exam result screens. */
function ExamDetailSkeleton({ sections = 4 }: Props) {
    return (
        <div role='status' aria-busy='true' aria-label='Loading exam' className={styles.wrapper}>
            <div className={styles.header}>
                <Skeleton width={220} height={18} />
                <div className={styles.header_meta}>
                    <Skeleton width={160} height={14} />
                    <Skeleton width={140} height={14} />
                    <Skeleton width={110} height={14} />
                </div>
            </div>

            {range(sections).map(section => <div key={section} className={styles.section}>
                <Skeleton width='35%' height={14} />
            </div>)}
        </div>
    );
};

export default ExamDetailSkeleton;
